import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAU2vDDiNdarEPq3n6REeM2Jkt5IYjS3Zg",
  authDomain: "brix-v2.firebaseapp.com",
  projectId: "brix-v2",
  storageBucket: "brix-v2.firebasestorage.app",
  messagingSenderId: "942109742957",
  appId: "1:942109742957:web:5cab85e7c73441f87d2c64",
  measurementId: "G-D6Q1J3HLSG"
};

// Inicializar Firebase solo si no hay una instancia existente
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

console.log("Firebase config:", firebaseConfig);

// Exportar servicios
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app; 